/* Nancy Editorial — kern.
   Alles hier is progressieve verbetering: zonder dit bestand blijft de winkel
   werken. Formulieren posten dan gewoon naar Shopify en links navigeren.

   Drie regels die uit eerdere thema's komen:
   - haken zijn data-attributen, nooit classes (classes zijn voor opmaak);
   - observers worden vastgehouden, anders ruimt de garbage collector ze op en
     vuren ze precies één keer;
   - custom elements worden defensief gedefinieerd, want de thema-editor laadt
     secties opnieuw in dezelfde pagina. */

(function () {
  'use strict';

  var instellingen = window.ncSettings || {};
  var teksten = window.ncStrings || {};

  // ------------------------------------------------------------- hulpjes --

  function geld(cent) {
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cent / 100);
    } catch (e) {
      return (cent / 100).toFixed(2);
    }
  }

  /* Een beeld wisselen zonder schok.

     Drie dingen tegelijk, en de volgorde is waar het om gaat.

     Het vervagen begint meteen. Wachtte hij eerst op het nieuwe bestand, dan
     gebeurde er na je klik seconden niets — de 1000ml-fles is 300 kB en komt
     bij de eerste keer van de server. Nu zie je meteen dat er iets verandert.

     Het nieuwe beeld wordt intussen ingeladen. Zonder dat stap je van een
     geladen foto naar een lege <img> en knippert er een wit vak.

     Gewisseld wordt er pas als beide klaar zijn: de vervaging én het bestand.
     Komt het uit de cache, dan wacht hij dus op de vervaging; is het traag, dan
     wacht de vervaging op hem. Blijft het bestand helemaal weg, dan wisselt de
     noodrem na 1200ms alsnog — een vak dat halfdoorzichtig blijft hangen is
     erger dan een harde wissel.

     De 160ms hoort bij de overgang van 180ms in component-product-card.css en
     theme.css; verander je de een, verander dan de ander.

     srcset moet weg vóór src iets doet: zolang die lijst er staat kiest de
     browser daaruit en negeert hij de nieuwe src.

     Staat beweging uit — thema-instelling of de voorkeur van de bezoeker zelf —
     dan wisselt hij hard zodra het beeld binnen is. */
  function beeldWissel(img, bron) {
    if (!img || !bron || img.getAttribute('src') === bron) return;

    function zet() {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', bron);
      img.classList.remove('is-wisselend');
    }

    var voorlader = new Image();

    if (beweegtNiet()) {
      voorlader.onload = zet;
      voorlader.onerror = zet;
      voorlader.src = bron;
      return;
    }

    var geladen = false;
    var vervaagd = false;
    var gedaan = false;

    function klaar() {
      if (gedaan || !geladen || !vervaagd) return;
      gedaan = true;
      zet();
    }

    img.classList.add('is-wisselend');

    setTimeout(function () {
      vervaagd = true;
      klaar();
    }, 160);

    setTimeout(function () {
      if (gedaan) return;
      gedaan = true;
      zet();
    }, 1200);

    voorlader.onload = function () {
      geladen = true;
      klaar();
    };
    voorlader.onerror = voorlader.onload;
    voorlader.src = bron;
  }

  // Ook de routinesecties wisselen beelden. Eén regel voor hoe dat eruitziet,
  // dus die halen hem hier op in plaats van hem na te bouwen.
  window.ncBeeldWissel = beeldWissel;

  function meld(bericht) {
    var vak = document.getElementById('Toast');
    if (!vak) return;
    vak.textContent = bericht;
    vak.hidden = false;
    clearTimeout(vak.__timer);
    vak.__timer = setTimeout(function () {
      vak.hidden = true;
    }, 3200);
  }

  function beweegtNiet() {
    if (instellingen.animation === 'none') return true;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // ------------------------------------------------------- winkelwagen ----

  var winkelwagen = {
    async toevoegen(formData) {
      var res = await fetch(instellingen.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      });
      if (!res.ok) {
        var fout = await res.json().catch(function () { return {}; });
        throw new Error(fout.description || teksten.cartError);
      }
      return res.json();
    },

    async wijzigen(sleutel, aantal) {
      var res = await fetch(instellingen.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: sleutel, quantity: aantal })
      });
      if (!res.ok) throw new Error(teksten.cartError);
      return res.json();
    },

    async ophalen() {
      var res = await fetch(instellingen.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      return res.json();
    },

    async tellerBijwerken() {
      var kar = await this.ophalen();
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = kar.item_count;
        el.hidden = kar.item_count === 0;
      });
      document.querySelectorAll('[data-cart-total]').forEach(function (el) {
        el.textContent = geld(kar.total_price);
      });
      document.dispatchEvent(new CustomEvent('nc:cart:updated', { detail: kar }));
      return kar;
    }
  };

  // ------------------------------------------------------------ overlays --
  // Eén beheerder voor alle panelen: Escape, focusval, focusherstel en
  // scrollslot zitten hier en niet in elke sectie apart.

  var overlays = {
    open: null,

    toon: function (id, aanroeper) {
      var paneel = document.getElementById(id);
      if (!paneel) return;
      this.sluitAlles();
      paneel.setAttribute('aria-hidden', 'false');
      paneel.__opener = aanroeper || document.activeElement;
      document.body.style.overflow = 'hidden';
      this.open = paneel;
      var eerste = paneel.querySelector('[autofocus], button, [href], input, select, textarea');
      if (eerste) eerste.focus();
    },

    sluit: function (id) {
      var paneel = typeof id === 'string' ? document.getElementById(id) : id;
      if (!paneel) return;
      paneel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (paneel.__opener && paneel.__opener.focus) paneel.__opener.focus();
      if (this.open === paneel) this.open = null;
    },

    sluitAlles: function () {
      var self = this;
      document.querySelectorAll('[data-overlay][aria-hidden="false"]').forEach(function (p) {
        self.sluit(p);
      });
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-overlay-open]');
    if (opener) {
      e.preventDefault();
      overlays.toon(opener.getAttribute('data-overlay-open'), opener);
      return;
    }
    var sluiter = e.target.closest('[data-overlay-close]');
    if (sluiter) {
      e.preventDefault();
      var paneel = sluiter.closest('[data-overlay]');
      overlays.sluit(paneel || sluiter.getAttribute('data-overlay-close'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlays.open) overlays.sluit(overlays.open);
  });

  // ------------------------------------------- in winkelwagen zonder sprong

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    var knop = form.querySelector('[data-add-to-cart]');
    if (!knop) return;

    e.preventDefault();
    var oud = knop.textContent;

    /* Een plusje van 30px is geen knop waar "Toegevoegd" in past. Zonder deze
       uitzondering liep dat woord dwars over het productkaartje op de
       campagnefoto heen: de knop staat op flex:none, dus hij groeit niet mee en
       de tekst loopt er gewoon uit. Zulke knoppen dragen data-add-kort en
       krijgen een vinkje in plaats van een zin; wát er is toegevoegd staat al
       in hun aria-label. */
    var kort = knop.hasAttribute('data-add-kort');

    knop.disabled = true;
    if (!kort) knop.textContent = teksten.adding || oud;

    winkelwagen
      .toevoegen(new FormData(form))
      .then(function () {
        knop.textContent = kort ? '✓' : (teksten.added || oud);
        return winkelwagen.tellerBijwerken();
      })
      .then(function () {
        if (instellingen.cartType === 'drawer' && document.getElementById('CartDrawer')) {
          overlays.toon('CartDrawer', knop);
        }
      })
      .catch(function (err) {
        meld(err.message || teksten.cartError);
      })
      .finally(function () {
        setTimeout(function () {
          knop.disabled = false;
          knop.textContent = oud;
        }, 1200);
      });
  });

  // -------------------------------------------- variantkeuze op de kaart --

  /* Voor de winkelwagen hoeft hier niets te gebeuren: de keuzelijst heet 'id'
     en post zichzelf mee. Het kaartje moet wél bijblijven. Kies je 1000ml, dan
     hoort daar de foto, de prijs en de maat van díé fles bij — bleef dat staan,
     dan koop je iets anders dan je ziet.

     Alles wat nodig is staat als tekst op de optie, door Liquid opgemaakt in
     hetzelfde geldformaat als de rest van de winkel. Hier wordt niets gerekend.

     Ontbreekt de doorgestreepte prijs in de HTML, dan had de maat die er bij
     het laden stond geen korting en is er ook geen element om te vullen. De
     prijs klopt dan nog steeds; alleen de streep blijft weg tot de pagina
     opnieuw laadt. */
  document.addEventListener('change', function (e) {
    var keuze = e.target;
    if (!keuze.matches || !keuze.matches('[data-kaart-maat]')) return;

    var kaart = keuze.closest('[data-kaart]');
    var optie = keuze.options[keuze.selectedIndex];
    if (!kaart || !optie) return;

    beeldWissel(kaart.querySelector('.card__media img'), optie.dataset.beeld);

    var nu = kaart.querySelector('.price__now');
    if (nu && optie.dataset.prijs) nu.textContent = optie.dataset.prijs;

    var korting = optie.dataset.korting;
    var blok = kaart.querySelector('.price');
    if (blok) blok.classList.toggle('price--sale', !!korting);

    var was = kaart.querySelector('.price__was');
    if (was) {
      was.textContent = optie.dataset.was || '';
      was.hidden = !korting;
    }

    var badge = kaart.querySelector('.price__badge');
    if (badge) {
      badge.textContent = '\u2212' + korting + '%';
      badge.hidden = !korting;
    }

    var maat = kaart.querySelector('.card__size');
    if (maat && optie.dataset.maat) maat.textContent = optie.dataset.maat;
  });

  // ------------------------------------------------------ uitklapbaar ----

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-accordion-toggle]');
    if (!knop) return;
    var open = knop.getAttribute('aria-expanded') === 'true';
    knop.setAttribute('aria-expanded', open ? 'false' : 'true');
    var paneel = document.getElementById(knop.getAttribute('aria-controls'));
    if (paneel) paneel.hidden = open;
  });

  // --------------------------------------------------- hoogte van de kop --
  // Meerdere componenten moeten weten waar de onderkant van de header zit.
  // getBoundingClientRect().bottom, niet .height: de kop kan gedeeltelijk
  // weggeschoven zijn. De waarnemer wordt vastgehouden aan window.

  function kopMeten() {
    var kop = document.querySelector('[data-header]');
    if (!kop) return;
    var onder = Math.max(0, kop.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-offset', onder + 'px');
    document.documentElement.style.setProperty('--header-height', kop.offsetHeight + 'px');
  }

  var gepland = false;
  window.addEventListener(
    'scroll',
    function () {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(function () {
        kopMeten();
        gepland = false;
      });
    },
    { passive: true }
  );

  if ('ResizeObserver' in window) {
    window.__ncKopWaarnemer = new ResizeObserver(kopMeten);
    var kopEl = document.querySelector('[data-header]');
    if (kopEl) window.__ncKopWaarnemer.observe(kopEl);
  }

  // ------------------------------------------------------ thema-editor ----
  // De editor vervangt een sectie zonder de pagina te herladen.

  document.addEventListener('shopify:section:load', function () {
    kopMeten();
    voetmenusDicht();
    if ('ResizeObserver' in window && window.__ncKopWaarnemer) {
      var el = document.querySelector('[data-header]');
      if (el) window.__ncKopWaarnemer.observe(el);
    }
  });

  /* De footermenu's staan in de markup open — een dicht details-element laat
     zijn inhoud in moderne browsers niet meer met CSS tonen, dus dicht-met-
     CSS-openen kán niet meer. Op een telefoon horen het inklapbare vakjes te
     zijn; dit klapt ze daar dicht. Zonder JavaScript blijven ze open staan,
     en dat is het juiste gedrag: liever alles zichtbaar dan onbereikbaar. */
  function voetmenusDicht() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('details.voet__menu[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }
  voetmenusDicht();

  /* Kiest de winkelier in de editor een overlay-sectie (het winkelwagenpaneel,
     het menu, de zoeklade), dan forceert de editor hem zichtbaar zónder dat de
     open-stand aangaat: een kaal wit vlak zonder achtergrond of positie. Hier
     wordt het paneel dan echt geopend, en bij het wegklikken weer gesloten. */
  document.addEventListener('shopify:section:select', function (e) {
    var overlay = e.target.querySelector('[data-overlay]');
    if (overlay) overlays.toon(overlay.id);
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    var overlay = e.target.querySelector('[data-overlay]');
    if (overlay) overlays.sluit(overlay);
  });

  // ----------------------------------------------------------- exporteren -

  window.ncCart = winkelwagen;
  window.ncOverlay = overlays;
  window.ncToast = { toon: meld };
  window.ncMoney = geld;
  window.ncReducedMotion = beweegtNiet;

  kopMeten();
})();

/* In de menulade is het label een link en het teken de uitklapper. Een klik op
   een link binnen een summary laat de browser standaard óók de details
   omklappen; dat is hier ongewenst, want je gaat weg van de pagina. Vandaar dat
   we het standaardgedrag tegenhouden en zelf navigeren.

   Zonder dit script werkt het nog steeds: dan klapt de lade even open en volgt
   de link daarna alsnog. */
document.addEventListener('click', function (e) {
  var link = e.target.closest('summary .lade__label');
  if (!link || !link.href) return;
  e.preventDefault();
  window.location.href = link.href;
});

/* Fotovlak van een productkaart: opent het adres van de titellink (die volgt de gekozen variant). */
(function () {
  function openKaart(e) {
    var vlak = e.target.closest && e.target.closest('[data-kaart-link]');
    if (!vlak || e.target.closest('a, button, input, label, select')) return;
    if (e.type === 'auxclick' && e.button !== 1) return;
    var kaart = vlak.parentNode;
    var link = kaart && kaart.querySelector('.card__title');
    var url = link && link.getAttribute('href');
    if (!url) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) window.open(url, '_blank');
    else window.location.href = url;
  }
  document.addEventListener('click', openKaart);
  document.addEventListener('auxclick', openKaart);
})();

/* Mobiel menu: de lijst staat in een <template> (sections/header.liquid). Erin zetten na het laden
   of eerder bij de eerste tik op de menuknop. */
(function () {
  function vul() {
    var t = document.querySelector('template[data-mobiel-menu-lijst]');
    if (t) t.replaceWith(t.content.cloneNode(true));
  }
  function bijMenuknop(e) {
    if (e.target.closest && e.target.closest('[data-overlay-open="MobielMenu"]')) vul();
  }
  document.addEventListener('pointerdown', bijMenuknop, { capture: true, passive: true });
  document.addEventListener('click', bijMenuknop, true);
  if (document.readyState === 'complete') vul();
  else window.addEventListener('load', vul, { once: true });
})();

/* Zoek-woordenlijst: merken, collecties en soorten komen pas bij gebruik (snippets/zoek-woordenlijst).
   Bij focus op een zoekveld of in rust na het laden; daarna 'nc:zoeklijst' zodat de zoekbalk zijn
   lijst opnieuw opbouwt. */
(function () {
  var bezig = false;
  function laad() {
    var bron = window.ncZoekLijst;
    if (bezig || !bron || bron.__compleet) return;
    bezig = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=nc-zoek-woordenlijst', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nc-zoeklijst]');
        if (!el) throw new Error('leeg');
        var d = JSON.parse(el.textContent);
        bron.merken = d.merken || [];
        bron.collecties = d.collecties || [];
        bron.soorten = d.soorten || [];
        bron.__compleet = true;
        document.dispatchEvent(new CustomEvent('nc:zoeklijst'));
      })
      .catch(function () { bezig = false; });
  }
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="search"], input[name="q"]')) laad();
  });
  var rust = function () {
    if ('requestIdleCallback' in window) window.requestIdleCallback(laad, { timeout: 6000 });
    else setTimeout(laad, 3000);
  };
  if (document.readyState === 'complete') rust();
  else window.addEventListener('load', rust, { once: true });
})();
